import React, { ReactElement } from 'react';

import {
  Container,
  Grid,
  Paragraph,
  Text,
  Link,
  GridItem,
  Heading,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';
import { Button } from 'components/tagging';
import dataQaIds from 'dataModel/dataQaIds';

import {
  StyledBox,
  LinkWrapper,
  ButtonWrapper,
} from './TriageStartPage.styled';
import { TriageStartPageContent } from './TriageStartPageContent';
import { JOURNEY_STEPS } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';
import { StyledImage } from '../fullSignatoryPage/FullSignatoryPage.styled';

function TriageStartPage(): ReactElement {
  const { triageStartPageContent } = useContent<TriageStartPageContent>();
  const navigate = useNavigate();

  React.useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION.TRIAGE_START_PAGE,
    );
  }, []);

  const handleNavigation = (path: string): void => {
    navigate(path);
  };

  return (
    <StyledBox>
      {triageStartPageContent &&
        triageStartPageContent.map(
          ({
            imageSrc,
            imageAltText,
            description1,
            description2,
            nextButton,
            nextBtnHref,
            previousLink,
            previousHref,
          }) => (
            <Container className="inner-container" key="container">
              <StyledImage
                alt={imageAltText}
                src={imageSrc}
                data-qa-id={dataQaIds.triageStartPage.illustrationImg}
              />
              <Paragraph align="center" marginTop="05">
                <Heading
                  size="s5"
                  align="center"
                  data-qa-id={dataQaIds.triageStartPage.descriptionText1}
                  marginBottom="07"
                >
                  {description1}
                </Heading>
                <Heading
                  size="s5"
                  align="center"
                  data-qa-id={dataQaIds.triageStartPage.descriptionText2}
                >
                  {description2}
                </Heading>
              </Paragraph>
              <Grid alignX="center">
                <GridItem>
                  <ButtonWrapper>
                    <Button
                      variation="primary"
                      width="fluid"
                      onClick={() => handleNavigation(nextBtnHref)}
                      taggingLabel={nextButton}
                      data-qa-id={dataQaIds.triageStartPage.nextButton}
                    >
                      {nextButton}
                    </Button>
                  </ButtonWrapper>
                </GridItem>
                <GridItem sm={12}>
                  <LinkWrapper>
                    <Link
                      iconPosition="left"
                      href={previousHref}
                      data-qa-id={dataQaIds.triageStartPage.previousPageLink}
                    >
                      <Text size="s2">{previousLink}</Text>
                    </Link>
                  </LinkWrapper>
                </GridItem>
              </Grid>
            </Container>
          ),
        )}
    </StyledBox>
  );
}

export default TriageStartPage;
